import { render, staticRenderFns } from "./feedbackNote.vue?vue&type=template&id=218d5460"
import script from "./feedbackNote.vue?vue&type=script&lang=js"
export * from "./feedbackNote.vue?vue&type=script&lang=js"
import style0 from "./feedbackNote.vue?vue&type=style&index=0&id=218d5460&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports